import html2canvas from 'html2canvas';
Vue.prototype.$html2canvas = html2canvas;
import {getAbsTop} from './globalFunction';
Vue.directive('sticky', {
    inserted: function (el, binding) {
        let num=0;
        let basicheight = getAbsTop(el) + 410;
        window.onscroll = () => {
            let scrollnum =  document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if(Math.abs(scrollnum-num)>10){
                let item = localStorage.getItem("marginTop");
                if(scrollnum>(basicheight-binding.value.targetheight)){
                    el.style.cssText=`position:fixed;top:${binding.value.targetheight}px;${binding.value.sticStyle}`
                }else{
                    el.style.cssText=`position:relative;margin-top:${item}`;
                }
                num=scrollnum;
            }
        }
    }
})

// input输入内容需要为number
Vue.directive('number', {
    inserted(el, binding) {
        const input = el.querySelector('input');
        if (!input) return;

        // 解析配置参数，默认不允许小数和负数
        const config = binding.value || {};
        const allowDecimal = config.allowDecimal || false;
        const allowNegative = config.allowNegative || false;

        // 构建正则表达式
        const pattern = `^${allowNegative ? '-?' : ''}\\d*${allowDecimal ? '(\\.\\d*)?' : ''}$`;
        const regex = new RegExp(pattern);
        let lastValidValue = '';

        // 输入处理函数
        const handleInput = (e) => {
            const value = e.target.value;
            if (value === '' || regex.test(value)) {
                lastValidValue = value;
            } else {
                // 回退到上一次有效值并触发更新
                e.target.value = lastValidValue;
                e.target.dispatchEvent(new Event('input', { bubbles: true }));
            }
        };

        // 添加事件监听
        input.addEventListener('input', handleInput);
        el._handleInput = handleInput; // 保存引用以便解绑
    },
    unbind(el) {
        const input = el.querySelector('input');
        if (input && el._handleInput) {
            input.removeEventListener('input', el._handleInput);
            delete el._handleInput;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/js/directive.js